import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  TableCell,
  TableRow,
  Checkbox,
  MenuItem,
  Menu,
  Button
} from '@material-ui/core';
import {
  updateRequestRestrictAccessApi
} from 'api';
import { RequestAccessStatus } from 'helpers/orders';


const defaultCustomerGroups = [
  {
    code: 'Not Logged In',
    id: 0
  },
  {
    code: 'General',
    id: 1
  }
];


const RequestAccessRow = ({requestAccessRowData, isItemSelected, handleSelectCustomerRow}) => {
  const dispatch = useDispatch();
  const {group_id, id} = requestAccessRowData;
  const { customerGroups, requestAccessCustomersList } = useSelector((state: IReduxState) => state.customers);
  const code = [...defaultCustomerGroups, ...customerGroups].find((groupItem) => groupItem.id == group_id)?.code || '';
  const currentRestrictAccessRequest =  requestAccessCustomersList.find((customer) => customer.id === id);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleChangeAcceess = (value) => {
    const updatedParamsAccess = [{id: currentRestrictAccessRequest.id, request_access: value}];
    updateRequestRestrictAccessApi({dispatch, updatedParamsAccess});
    setAnchorEl(null);
  };


  return (
    <TableRow>
      <TableCell>
        <Checkbox
          color="primary"
          checked={isItemSelected}
          onChange={(event) => handleSelectCustomerRow(requestAccessRowData, event.target.checked)}
        />
      </TableCell>
      <TableCell>
        {requestAccessRowData.id}
      </TableCell>
      <TableCell>
        {requestAccessRowData.email}
      </TableCell>
      <TableCell>
        {requestAccessRowData.firstname}
      </TableCell>
      <TableCell>
        {requestAccessRowData.lastname}
      </TableCell>
      <TableCell>
        {code}
      </TableCell>
      <TableCell>
        {RequestAccessStatus[requestAccessRowData.request_access] || ''}
      </TableCell>
      <TableCell>
        <div>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            aria-controls={anchorEl ? 'select-menu' : undefined}
            aria-haspopup="menu"
            aria-expanded={Boolean(anchorEl) ? 'true' : undefined}
            onClick={(event) => setAnchorEl(event.currentTarget)}
          >
            Select
          </Button>
          <Menu
            elevation={8}
            id="select-menu"
            anchorEl={anchorEl}
            open={!!anchorEl}
            aria-haspopup="true"
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem onClick={() => handleChangeAcceess('access_restricted')}>Restrict</MenuItem>
            <MenuItem onClick={() => handleChangeAcceess('access_granted')}>Grant</MenuItem>
          </Menu>
        </div>
      </TableCell>
    </TableRow>
  );
};


export default RequestAccessRow;
